const e=e=>e?Object.keys(e):[],t=e=>e?Object.entries(e):[];export{e as getCustomParamsArray,t as getCustomParamsForTargetting};
